module.exports = __webpack_public_path__ + "static/driveway - 2-81b236804d092c9d0992d2f0981609a4.jpg";